/**
 * Sprava relaci uzlu. Pokud pride ID uzlu, tak se automaticky dotahnou vazby (FAQ) na dalsi uzly (strom).
 * Setovani id aktualniho uzlu se provadi pres setId.
 */
import React, { createContext, useContext, useEffect, useState } from 'react';

import { useAxios } from './Axios';
import { ApiRelationBody, Relation } from '../api/models';

export interface IRelation {
    id: number
    textShort: string
    textLong: string
}

export interface IRelations {
    relations: Array<IRelation>
    setId: (id: number) => void
}


export const RelationsContext = createContext<IRelations>({
    relations: [],
    setId: (id: number) => { }
});

export const useRelations = () => {
    return useContext(RelationsContext);
};

interface IRelationsProps {
    children: any
}

function Relations({ children }: IRelationsProps) {
    const axios = useAxios();
    const [id, setId] = useState(0);
    const [relations, setRelations] = useState<IRelation[]>([]);

    //dotahovani vazeb aktualniho uzlu
    useEffect(
        () => {
            setRelations([]);

            if (!id) return;
            axios.post<Relation[]>('relation', { parentId: id } as ApiRelationBody)
                .then((response) => {
                    setRelations(response.data);
                })
                .catch((error) => {
                    console.error(error);
                });
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [id]
    );

    return (
        <RelationsContext.Provider value={{ relations, setId }}>
            {children}
        </RelationsContext.Provider>
    );
}

export default Relations;
